module.exports = __webpack_public_path__ + "img/Rajam Iyer.9866d27b.jpeg";